// import alert from '@/plugins/alert'
import { UniformOrders, UniformConfig, Class } from '@/plugins/api'
import { rangeRight, get } from 'lodash'
import moment from 'moment'

export default {
  namespaced: true,
  state: {
    loading: false,
    uniformOrdersData: {},
    count: 0,
    search: [],
    pageText: '',
    itemsPerPage: 10,
    uniformOrdersSearchParams: {},
    totalItems: 0,
    uniformOrderss: [],
    date: moment().startOf('day').toISOString(),
    uniformConfig: {},
  },
  actions: {
    // Lấy thông tin cấu hình đăng ký đồng phục
    async fetchUniformConfig({ commit }) {
      commit('changeState', { loading: true })
      try {
        const response = await UniformConfig.search({})
        commit('changeState', { uniformConfig: response })
      } catch (error) {
        console.error('Lỗi khi lấy cấu hình đăng ký đồng phục :', error)
      } finally {
        commit('changeState', { loading: false })
      }
    },
    async fetchUniformOrder({ commit }, orderId) {
      commit('setUniformOrder', null)
      const order = await UniformOrders.fetchOne(orderId)
      commit('setUniformOrder', order)
    },
    // Cập nhật trạng thái Mở / Đóng đăng ký đồng phục
    async toggleRegistrationStatus({ dispatch, state }) {
      try {
        const currentStatus = state.uniformConfig.isOpen
        await UniformConfig.create({ isOpen: !currentStatus })
        await dispatch('fetchUniformConfig')
      } catch (error) {
        console.error('Lỗi khi cập nhật trạng thái đăng ký:', error)
      }
    },
    async getUniformOrdersRegisterByStudents({ commit }, query) {
      commit('changeState', { loading: true })

      query.fromDate = query.fromDate || moment().startOf('month').toISOString()
      query.toDate = query.toDate || moment().endOf('day').toISOString()

      // const timeGte = moment(query.date).startOf('day')
      // let lastTimeOrder = timeGte.clone().add(13, 'hours')
      // if (timeGte.toISOString() === '2023-10-28T17:00:00.000Z') {
      //   lastTimeOrder = moment('2023-10-31T12:00:00.000Z')
      // }
      // query = {
      //   ...query,
      //   lastTimeToEat: lastTimeOrder.toISOString(),
      // }
      const uniformOrderss = await UniformOrders.getUniformOrdersRegisterByStudents(query)
      commit('changeState', { uniformOrderss, uniformOrdersSearchParams: query, loading: false })
    },
    async searchUniformOrdersList({ commit, state, dispatch }, query) {
      const uniformOrdersSearchParams = {
        _limit: state.itemsPerPage,
        ...query,
      }

      commit('changeState', { uniformOrdersSearchParams })
      dispatch('requestPageSettings', {})
    },
    async requestPageSettings({ state, commit, dispatch }, { page, itemsPerPage }) {
      commit('changeState', { loading: true })
      if (!page) page = 1
      if (!itemsPerPage) itemsPerPage = state.itemsPerPage
      if (state.uniformOrdersSearchParams) {
        const uniformOrdersSearchParams = {
          ...state.uniformOrdersSearchParams,
          date: state.date,
          _start: (page - 1) * itemsPerPage,
          _limit: itemsPerPage,
          _sort: 'nameToNumber:ASC',
        }
        const [totalItems, uniformOrderss] = await Promise.all([
          UniformOrders.count(uniformOrdersSearchParams),
          UniformOrders.search(uniformOrdersSearchParams),
        ])
        await Promise.all(
          uniformOrderss.map(async sm => {
            const currentClass = await Class.fetchOne(sm.student.currentClass)
            sm.class = currentClass
          })
        )
        if (totalItems > (page - 1) * itemsPerPage || page === 1) {
          commit('changeState', {
            uniformOrderss,
            totalItems,
            itemsPerPage,
            uniformOrdersSearchParams,
          })

          const pageStart = (page - 1) * itemsPerPage + 1
          let pageStop = page * itemsPerPage
          pageStop = pageStop > totalItems || pageStop === -1 ? totalItems : pageStop
          const pageText = `${pageStart}-${pageStop} trên ${totalItems}`
          commit('setPageText', pageText)
        } else {
          var pages = rangeRight(1, page)
          for (let index = 0; index < pages; index++) {
            const selectedPage = pages[index]
            if (totalItems > (selectedPage - 1) * itemsPerPage) {
              dispatch('requestPageSettings', {})
              break
            }
          }
        }
      }

      commit('changeState', { loading: false })
    },
    async createUniformOrders({ commit, state }, uniformOrdersData) {
      const c = await UniformOrders.create(uniformOrdersData)
      return c
    },
    async updateUniformOrders({ commit, state }, { id, ...uniformOrdersData }) {
      const d = await UniformOrders.update(id, uniformOrdersData)
      //   commit('updateUniformOrders', d)
      return d
    },
    async updateStatusStudent({ commit, state }, { id, ...uniformOrdersData }) {
      const d = await UniformOrders.updateStatusStudent(id, uniformOrdersData)
      //   commit('updateUniformOrders', d)
      return d
    },
    async removeUniformOrders({ commit }, id) {
      await UniformOrders.remove(id)
      commit('removeUniformOrders', id)
    },
    setUniformOrders({ commit }, uniformOrdersData) {
      commit('setUniformOrders', uniformOrdersData)
    },
    setDate({ commit }, date) {
      commit('changeState', { date })
    },
  },
  mutations: {
    setPageText(state, pageText) {
      state.pageText = pageText
    },
    updateUniformOrders(state, uniformOrdersData) {
      const uniformOrderss = state.uniformOrderss.map(c => {
        if (uniformOrdersData.id === c.id) return uniformOrdersData
        else return c
      })
      state.uniformOrderss = uniformOrderss
    },
    updateStatusStudent(state, uniformOrdersData) {
      const uniformOrderss = state.uniformOrderss.map(c => {
        if (uniformOrdersData.id === c.id) return uniformOrdersData
        else return c
      })
      state.uniformOrderss = uniformOrderss
    },
    removeUniformOrders(state, id) {
      const uniformOrderss = state.uniformOrderss.filter(d => d.id !== id)
      state.uniformOrderss = uniformOrderss
    },
  },
  getters: {},
}
